
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import {
		handleClipboard
	} from '@/utils/clipboard'
  import message from '@/components/message.vue';
  import {
    financechoseInvoiceInfo,
    financeserviceContractInvoiceOpenInvoice
  } from "@/api/finance"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-message': message,
    }
  })

  export default class ProductList extends Vue {
    private list:any = []
    private all = 0
    private conShow = false
    private pageloading = false

    private mounted () {
      this.getinfo()
    }
    private async getinfo(){
      try{
        this.pageloading = true
        let res:any = await financechoseInvoiceInfo({
          IdList:this.$route.query.list
        })
        if(res.IsSuccess){
          this.all = 0
          this.list = res.Result.map(v=>{
            this.all += v.ServiceFee
            return v
          })
        }
      }finally{
        this.pageloading = false
      }
    }
    private async confirminvoice(){
      try{
        this.pageloading = true
        let res:any = await financeserviceContractInvoiceOpenInvoice({
          IdList:this.$route.query.list
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.$router.go(-1)
        }
      }finally{
        this.pageloading = false
      }
    }
    private getCopy(e,row){
      let text = ''
      text += `开票金额：￥${row.ServiceFee}\n`
      text += `发票抬头：${row.EnterpriseName}\n`
      if(row.EnterpriseTaxNo){
        text += `企业税号：${row.EnterpriseTaxNo}\n`
        text += `企业地址：${row.EnterpriseAddress}\n`
        text += `企业电话：${row.EnterprisePhone}\n`
        text += `开户银行：${row.EnterpriseOpenBankAndAccount}\n`
      }
      handleClipboard(text,e)
    }
  }
